var map = {
	"./area-1.png": 43,
	"./area-2.png": 44,
	"./area-3.png": 45,
	"./area-4.png": 46,
	"./background-cork.jpg": 47,
	"./background-dark.svg": 48,
	"./background-frame.png": 49,
	"./background-grass1.png": 50,
	"./background-grass2.png": 51,
	"./background-grass3.png": 52,
	"./background-header.svg": 53,
	"./background-landingpage.png": 54,
	"./background-pairs.png": 55,
	"./background-plant1.png": 56,
	"./background-plant2.png": 57,
	"./background-plant3.png": 58,
	"./background-plant4.png": 59,
	"./background-plant5.png": 60,
	"./background-popup.svg": 61,
	"./background-popup1.jpg": 62,
	"./background-popup2.png": 63,
	"./background-roomOverview.svg": 64,
	"./background.svg": 65,
	"./bonus.svg": 66,
	"./cookie/cookies-accepted.svg": 67,
	"./cookie/cookies-notAccepted.svg": 68,
	"./datadyst-logo-english.svg": 69,
	"./datadyst-logo.svg": 70,
	"./hexagon/hexagon-challenge-completed.svg": 71,
	"./hexagon/hexagon-challenge-selected.svg": 72,
	"./hexagon/hexagon-empty.svg": 73,
	"./hexagon/hexagon-inner-1.svg": 74,
	"./hexagon/hexagon-inner-10.svg": 75,
	"./hexagon/hexagon-inner-11.svg": 76,
	"./hexagon/hexagon-inner-12.svg": 77,
	"./hexagon/hexagon-inner-13.svg": 78,
	"./hexagon/hexagon-inner-14.svg": 79,
	"./hexagon/hexagon-inner-2.svg": 80,
	"./hexagon/hexagon-inner-3.svg": 81,
	"./hexagon/hexagon-inner-4.svg": 82,
	"./hexagon/hexagon-inner-5.svg": 83,
	"./hexagon/hexagon-inner-6.svg": 84,
	"./hexagon/hexagon-inner-7.svg": 85,
	"./hexagon/hexagon-inner-8.svg": 86,
	"./hexagon/hexagon-inner-9.svg": 87,
	"./hexagon/hexagon.svg": 88,
	"./icon-arrow-down.svg": 89,
	"./icon-arrow.svg": 90,
	"./icon-back-dark.svg": 91,
	"./icon-back.png": 92,
	"./icon-back.svg": 93,
	"./icon-datatilsynet-logo.svg": 94,
	"./icon-flag-danish.svg": 95,
	"./icon-flag-english.svg": 96,
	"./icon-info.svg": 97,
	"./icon-leaf-green.svg": 98,
	"./icon-leaf-orange.svg": 99,
	"./icon-leaf.svg": 100,
	"./icon-lock.svg": 101,
	"./icon-play.svg": 102,
	"./icon-x.svg": 103,
	"./icon-zoom.svg": 104,
	"./loading.gif": 105,
	"./loading.svg": 106,
	"./logo-cgl.png": 107,
	"./logo-snm-big.png": 108,
	"./logo-snm.svg": 109,
	"./phone/phone-1.svg": 110,
	"./phone/phone-2.svg": 111,
	"./phone/phone-3.svg": 112,
	"./phone/phone-4.svg": 113,
	"./phone/phone-5.svg": 114,
	"./phone/phone-6.svg": 115,
	"./t-rex.svg": 116,
	"./title.svg": 117,
	"./trophy/icon-trophy-bronze.svg": 118,
	"./trophy/icon-trophy-empty.svg": 119,
	"./trophy/icon-trophy-gold.svg": 120,
	"./trophy/icon-trophy-silver.svg": 121,
	"./trophyRoom/trophy-bronze.svg": 122,
	"./trophyRoom/trophy-confetti.svg": 123,
	"./trophyRoom/trophy-gold.svg": 124,
	"./trophyRoom/trophy-silver.svg": 125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;